import * as React from 'react'
import { Container } from 'reactstrap'
import { I18n } from 'react-redux-i18n'

import './styles.scss'
import { BrandsAndDelegations } from 'components/Form'
import ResourcesList from './ResourcesList'
import { companyResources } from 'api'
import ResourcesDetail from './ResourcesDetail'

const Index = (props) => {
  const [brands, setBrands] = React.useState([])
  const [delegations, setDelegations] = React.useState([])
  const [showModalFiles, setShowModalFiles] = React.useState(false)
  const onToggleModalFiles = () => setShowModalFiles(!showModalFiles)
  const [resources, setResources] = React.useState([])
  const [valuesToEdit, setValuesToEdit] = React.useState({})
  const [isSubmitting, setIsSubmitting] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState(false)

  React.useEffect(()=> {
    getResources(brands, delegations)
  }, [brands, delegations])

  React.useEffect(()=> {
    if (!showModalFiles)
      setValuesToEdit({})
  }, [showModalFiles])

  const onChange = (value, type) => {
    setErrorMessage(false)
    if (type === 'brand') {
      setBrands(value)
    }
    else if (type === 'delegation') {
      setDelegations(value)
    }
  }

  const save = async (_resource) => {
    setIsSubmitting(true)

    const brandsToSave = []
    _resource.brands.forEach(it => {
      const id = it.value || it._id
      if (id !== 'all' ) {
        brandsToSave.push({ _id: id, name: it.label || it.name })
      }
    })
    const delegationsToSave = []
    _resource.delegations.forEach(it => {
      const id = it.value || it._id
      if (id !== 'all') {
        delegationsToSave.push({ _id: id, name: it.label || it.name, brand: it.brand || it.data.brand || it.data.data.brand })
      }
    })

    const resource = _resource._id ? {
      _id: _resource._id,
      typeUpload: "userFile",
      name: _resource.name,
      brands: brandsToSave,
      delegations: delegationsToSave,
    } : {
      //files: _resource.files,
      name: _resource.name,
      typeUpload: "userFile",
      brands: brandsToSave,
      delegations: delegationsToSave,
    }

    if (resource._id) {
      companyResources.put(resource._id, resource).then(result => {
        onToggleModalFiles()
        getResources(brands, delegations)
        setIsSubmitting(false)
      }).catch(error => {
        setIsSubmitting(false)
        console.error(error)
      })
    }
    else {
      const formData = new FormData()
      formData.append('data', JSON.stringify(resource))
      formData.append('files', _resource.files)
      companyResources.post(formData).then(result => {
        onToggleModalFiles()
        getResources(brands, delegations)
        setIsSubmitting(false)
      }).catch(error => {
        setIsSubmitting(false)
        console.error(error)
      })
    }
  }

  const getResources = (_brands, _delegations) => {
    setErrorMessage(false)
    let brandsToSend = []
    let delegationsToSend = []

    _brands.forEach(it => {
      if (it.value !== 'all')
        brandsToSend.push(it.value)
    })

    _delegations.forEach(it => {
      if (it.value !== 'all')
        delegationsToSend.push(it.value)
    })

    companyResources.get(brandsToSend.join(), delegationsToSend.join()).then(result => {
      if (result.data.length === 0) {
        setErrorMessage(I18n.t('resources_not_data'))
      }
      setResources(result.data)
    }).catch(error => {
      console.log(error)
    })
  }

  const editModal = (resource) => {
    setValuesToEdit(resource)
    onToggleModalFiles()
  }

  return (
    <div className='animated fadeIn'>
      <Container fluid className='py-5 resources-configuration'>
        <div className='wrapper-resources section mb-4'>
          <h1>{I18n.t('dashboard_resources')}</h1>
          <legend dangerouslySetInnerHTML={{ __html: I18n.t('resources_subtitle') }} />

          <div className='seccion-0'>
            <BrandsAndDelegations
              onChangeBrands={(value)=> onChange(value, 'brand')}
              currentBrands={brands || []}
              onChangeDelegations={(value)=> onChange(value, 'delegation')}
              currentDelegations={delegations || []}
            />
            <div className='wrapper-error animated fadeIn'>
              <small className='error'>{errorMessage}</small>
            </div>
          </div>

          <div className='seccion-2'>
            <ResourcesList
              resources={resources}
              brands={brands}
              delegations={delegations}
              getResources={getResources}
              editModal={editModal}
            />
          </div>

          <div className={`add-file`} onClick={()=>onToggleModalFiles()}>
            <img src='img/icons/icon-arrow-up.svg' alt='add'/>
            <span>{I18n.t('dashboard_upload-file')}</span>
          </div>

          {showModalFiles && <ResourcesDetail
            brands={brands}
            delegations={delegations}
            resources={resources}
            isOpen={showModalFiles}
            toggle={onToggleModalFiles}
            save={save}
            valuesToEdit={valuesToEdit}
            isSubmitting={isSubmitting}
          />}

        </div>
      </Container>
    </div>
  )
}

export default Index
